var _defs, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsightfulReactionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 101.78 101.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4caf50;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2.24px;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.92,76.97v8.46c0,1.97-1.59,3.57-3.56,3.57h-12.94c-1.97,0-3.57-1.6-3.57-3.57v-8.46h20.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M60.92,76.97h-20.07v-5.32c0-2.91-1.37-5.6-3.56-7.53-5.09-4.48-7.94-11.45-6.65-19.01,1.51-8.88,8.97-15.85,17.92-16.83,12.4-1.36,22.9,8.3,22.9,20.44,0,6.09-2.65,11.56-6.86,15.32-2.27,2.02-3.69,4.82-3.69,7.85v5.07Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.85,76.97v-5.32c0-2.91-1.37-5.6-3.56-7.53-5.09-4.48-7.94-11.45-6.65-19.01,1.51-8.88,8.97-15.85,17.92-16.83,12.4-1.36,22.9,8.3,22.9,20.44,0,6.09-2.65,11.56-6.86,15.32-2.27,2.02-3.69,4.82-3.69,7.85v5.07h-20.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.85,76.97v8.46c0,1.97,1.6,3.57,3.57,3.57h12.94c1.97,0,3.56-1.6,3.56-3.57v-8.46"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 50.9,
    y1: 12.78,
    x2: 50.9,
    y2: 21.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 88.79,
    y1: 49.1,
    x2: 79.85,
    y2: 49.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 21.94,
    y1: 49.1,
    x2: 12.99,
    y2: 49.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 30.42,
    y1: 28.63,
    x2: 24.09,
    y2: 22.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 77.69,
    y1: 22.3,
    x2: 71.37,
    y2: 28.63
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M61.05,45.23c-7.16,2.51-9.18,6.41-9.78,11.86-.03.28-.04.57-.04.86v19.02"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.51,50.12l3.59.74s5.12,1.06,7.14,6.45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsightfulReactionIcon);
export default __webpack_public_path__ + "static/media/insightful-reaction-icon.5a4593344cec9d76936391d232574486.svg";
export { ForwardRef as ReactComponent };